import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";

import { Observable, from } from "rxjs";
import { map, tap } from "rxjs/operators";
import { TokenRefreshService } from "./token-refresh.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private tokens: TokenRefreshService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree>  {

    // Shares the single in-flight refresh with the interceptor and Apollo (no parallel refresh calls).
    return from(this.tokens.getValidToken())
      .pipe(
        map(token => Boolean(token?.isValid())),
        tap(isAuthenticated => {
          if (!isAuthenticated) {
            this.router.navigate(["/auth/login"], {
              queryParams: { returnUrl: state.url },
            });
          }
          return isAuthenticated;
        }),
      );
  }
}
